/**
 * @flow
 * @author: Vamsi Tallam
 * */

import styled from 'react-emotion'
import Colors from '../../../themes/Colors'
import { mobile, notMobile } from '../../../utils/mixins'

export const ModalBodyContainer = styled('section')`
  width: 100vw;
  background-color: ${Colors.blackTwo};
  background-position: center;
  background-size: cover;
  ${mobile} {
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 20px;
    ${'' /* height: 800px; */};
  }
  ${notMobile} {
    height: 100%;
  }
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media screen and (min-width: 768px) and (max-width: 1024px) {
    overflow: hidden;
  }
`
// TODO: intensionally kept in px, as the em behaviour is not proper
export const ModalWrapper = styled('div')`
  width: 100%;
  min-height: 100vh;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const CloseIconWrapper = styled('div')`
  width: 44px;
  height: 44px;
  border: solid 1px ${Colors.whiteTwo30};
  background-color: ${Colors.black20};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  cursor: pointer;
  position: absolute;
  right: 5%;
  top: 4%;
  z-index: 100;
  ${mobile} {
    position: absolute;
    right: 6%;
    top: 6%;
    padding-bottom: 0px;
    width: 36px;
    height: 36px;
  }
`



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/EnquireNowModal/styledComponents.js